import { useIsFetching, useIsMutating } from '@tanstack/react-query';

export function GlobalActivityIndicator() {
  const activeRequests = useIsFetching() + useIsMutating();
  if (activeRequests === 0) return null;

  return (
    <div aria-label="Waiting for the server" className="global-activity" role="status">
      <span aria-hidden="true" />
      <span className="sr-only">Waiting for the server to respond…</span>
    </div>
  );
}

export function InlineSpinner() {
  return <span aria-hidden="true" className="button-spinner" />;
}
